// extracted by css-extract-rspack-plugin
export default {"wrapper":"CliIcon-module__wrapper__eQrK4","connectedDot":"CliIcon-module__connectedDot__T61fA"};